import { useEffect, useState, useRef } from "react";

import getImgUrl from "../../helper/getImgUrl";
import api from '../../api/axios';
import styles from "../dash_styles/modifyabout.module.css";

import { CiTrash } from "react-icons/ci";
import { MdClose } from "react-icons/md";

const ModifyAbout = () => {
    const [pageData, setPageData] = useState({});
    const [skillsData, setSkillsData] = useState([]);
    const [isFeedOpen, setIsFeedOpen] = useState(false);

    const [formData, setFormData] = useState({
        main_title: '',
        commitment: '',
        main_photo: null
    });

    const [skillForm, setSkillForm] = useState({
        skill: '',
        skill_intro: '',
        skill_photo: null
    });

    const mainPhotoRef = useRef();

    const fetchCompanyData = async () => {
        try {
            const res = await api.get('/company');
            setPageData(res.data)
        } catch (error) {
            console.error('Error fetching comapny_data', error);
        }
    };

    const fetchCompanySkills = async () => {
        try {
            const res = await api.get('/company/skills')
            setSkillsData(res.data);
        } catch (error) {
            console.error('Error fetching company skills', error);
        }
    };

    useEffect(() => {
        fetchCompanyData();
        fetchCompanySkills();
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleInputSkillChange = (e) => {
        const { name, value } = e.target;
        setSkillForm((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: files[0]
        }));
    };

    const handleFileSkillChange = (e) => {
        const { name, files } = e.target;
        setSkillForm((prev) => ({
            ...prev,
            [name]: files[0]
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const submitData = new FormData();
            Object.entries(formData).forEach(([key, value]) => {
                if (value) submitData.append(key, value);
            });

            await api.put(
                '/company/update',
                submitData,
                { headers: { 'Content-Type': 'multipart/form-data' } }
            );
            
            await fetchCompanyData();
            setFormData({
                main_title: '',
                commitment: ''
            });

            mainPhotoRef.current.value = ''
        } catch (error) {
            console.error('Error updating company page');
        }
    };

    const deleteSkill = async (skillId) => {
        if (!window.confirm(`Are you sure you want to delete this skill?`)) return;

        try {
            await api.delete(`/company/skill/delete/${skillId}`);

            await fetchCompanySkills();
        } catch (error) {
            console.error('Error deleting skill', error);
            alert('Error deleting skill');
        }
    };

    const handleSkillSubmit = async (e) => {
        e.preventDefault();
        try {
            const submitData = new FormData();
            Object.entries(skillForm).forEach(([key, value]) => {
                if (value) submitData.append(key, value);
            });

            await api.post(
                '/company/skill/new',
                submitData,
                { headers: { 'Content-Type': 'multipart/form-data' } }
            );

            await fetchCompanySkills();
            setIsFeedOpen(false);
            setSkillForm({
                skill: '',
                skill_intro: '',
                skill_photo: null
            });
        } catch (error) {
            console.error('Error deleting skill', error);
            alert('Error adding new skill');
        }
    };

    const handleCancelSkillForm = () => {
        setSkillForm({
            skill: '',
            skill_intro: '',
            skill_photo: null
        })
        setIsFeedOpen(false);
    }

    return (
        <div className={styles.mainContainer}>
            <div className={styles.pageEdit}>
                <div className={styles.mainTableContainer}>
                    <div className={styles.labelContainer}>
                        <div className={styles.label}>
                            <p>Company page management</p>
                        </div>
                        <div className={styles.filterOrder}>
                            
                        </div>
                    </div>
                    <div className={styles.outerTable}>
                        <form onSubmit={handleSubmit}>
                            <table>
                                <thead>
                                    <tr>
                                        <th className={styles.col1}>content location</th>
                                        <th className={styles.col2}>content type</th>
                                        <th className={styles.col3}>content</th>
                                        <th className={styles.col4}>input</th>
                                        <th className={styles.col5}>action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Main title</td>
                                        <td>Text</td>
                                        <td>{pageData?.main_title}</td>
                                        <td>
                                            <input
                                                type='text'
                                                name='main_title'
                                                placeholder="Enter new title"
                                                value={formData.main_title}
                                                maxLength={50}
                                                onChange={handleInputChange}
                                            />
                                        </td>
                                        <td><button type='submit'>Apply change</button></td>
                                    </tr>
                                    <tr>
                                        <td>Commitment</td>
                                        <td>Text</td>
                                        <td>{pageData?.commitment}</td>
                                        <td>
                                            <textarea
                                                name='commitment'
                                                onChange={handleInputChange}
                                                className={styles.tableArea}
                                                value={formData.commitment}
                                                placeholder="Enter new commitment"
                                                maxLength={370}
                                            ></textarea>
                                        </td>
                                        <td><button type='submit'>Apply change</button></td>
                                    </tr>
                                    <tr>
                                        <td>Landing photo</td>
                                        <td>Picture</td>
                                        <td><img src={getImgUrl(pageData?.main_photo)} alt=''/></td>
                                        <td>
                                            <input
                                                type='file'
                                                name='main_photo'
                                                onChange={handleFileChange}
                                                ref={mainPhotoRef}
                                            />
                                        </td>
                                        <td><button type='submit'>Apply change</button></td>
                                    </tr>
                                </tbody>
                            </table>
                        </form>
                    </div>
                </div>
            </div>
            <div className={styles.feedback}>
                <div className={styles.mainTableContainer}>
                    <div className={styles.labelContainer}>
                        <div className={styles.label}>
                            <p>Skill management</p>
                        </div>
                        <div className={styles.filterOrder}>
                            <button onClick={() => setIsFeedOpen(prev => !prev)}>Add feedback</button>
                        </div>
                    </div>
                    <div className={styles.outerTable}>
                        <form onSubmit={handleSubmit}>
                            <table>
                                <thead>
                                    <tr>
                                        <th className={styles.col1}>skill</th>
                                        <th className={styles.col2}>skill photo</th>
                                        <th className={styles.col3}>content</th>
                                        <th className={styles.col5}>action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(skillsData) && skillsData.map(skill => (
                                        <tr key={skill.id}>
                                            <td><p>{skill.skill}</p></td>
                                            <td><img src={getImgUrl(skill.skill_photo)} alt='Skill'/></td>
                                            <td><p>{skill.skill_intro}</p></td>
                                            <td><CiTrash className={styles.deleteIcon} onClick={() =>deleteSkill(skill.id)}/></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </form>
                    </div>
                </div>
            </div>
            {isFeedOpen && (
                <div className={styles.addWrapper}>
                    <div className={styles.addFeedback}>
                        <div className={styles.topAdd}>
                            <h3>Add feedback</h3>
                            <MdClose className={styles.closeIcon} onClick={handleCancelSkillForm}/>
                        </div>
                        <div className={styles.middleAdd}>
                            <form id="feedForm" onSubmit={handleSkillSubmit}>
                                <div className={styles.formContainers}>
                                    <div className={styles.inputBox}>
                                        <p>skill</p>
                                        <input
                                            type="text"
                                            name="skill"
                                            placeholder="Enter skill name"
                                            maxLength={50}
                                            value={skillForm.skill}
                                            onChange={handleInputSkillChange}
                                        />
                                    </div>
                                    <div className={styles.inputBoxArea}>
                                        <p>skill intro</p>
                                        <textarea 
                                            name="skill_intro"
                                            placeholder="Enter skill description"
                                            value={skillForm.skill_intro}
                                            onChange={handleInputSkillChange}
                                            maxLength={200}
                                            className={styles.textareaAdd}
                                        ></textarea>
                                    </div>
                                </div>
                                <div className={styles.formContainers}>
                                    <div className={styles.inputBox}>
                                        <p>skill photo</p>
                                        <input
                                            type="file"
                                            name="skill_photo"
                                            onChange={handleFileSkillChange}
                                        />
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className={styles.bottomAdd}>
                            <button onClick={handleCancelSkillForm}>Cancel</button>
                            <button type="submit" form="feedForm" className={styles.save}>Save</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ModifyAbout;